
const rawBase = process.env.VUE_APP_API_BASE ?? "http://localhost:5001";
const isLocalHttps =
  rawBase.startsWith("https://localhost") ||
  rawBase.startsWith("https://127.0.0.1");
const API_BASE = isLocalHttps ? rawBase.replace(/^https:\/\//, "http://") : rawBase;

export default API_BASE;